import { render, staticRenderFns } from "./sortNum.vue?vue&type=template&id=d0e781b8&scoped=true&"
import script from "./sortNum.vue?vue&type=script&lang=js&"
export * from "./sortNum.vue?vue&type=script&lang=js&"
import style0 from "./sortNum.vue?vue&type=style&index=0&id=d0e781b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0e781b8",
  null
  
)

export default component.exports